// @flow

import React, { PureComponent } from 'react';
import Translate from 'client/components/translate';
import LinkButton from 'client/components/button/linkButton';
import Card from 'client/components/card/card';
import InputZip from 'client/components/form/inputZip';
import Testimonials from 'client/components/testimonials';
import { Tracking } from 'web-core/src/tracking';
import '../styles/visionLandingPage.scss';

type Props = {
  submitHandler: Function,
};

const visionBenefits = [
  {
    imgSrc:
      'https://images.contentful.com/heg7gyzix6dq/6iNW1jI4nYksQiuIIEkkWi/f4e90471660768a398f654a171462404/Glasses.svg',
    alt: 'glasses',
    headerPath: 'vision.landing.benefits.benefits',
    textPath: 'vision.landing.benefits.exam',
  },
  {
    imgSrc:
      'https://images.contentful.com/heg7gyzix6dq/6HtMCrT91myiim0Qmoy0Cu/8e73466b6b86727340008b2ea02ff29e/doctor.svg',
    alt: 'doctor',
    headerPath: 'vision.landing.benefits.doctors',
    textPath: 'vision.landing.benefits.specialists',
  },
  {
    imgSrc:
      'https://images.contentful.com/heg7gyzix6dq/2VphJeCJEc4eIWYKkGCI04/842b9ee099346d967ef4887577062a17/Clock.svg',
    alt: 'clock',
    headerPath: 'vision.landing.benefits.noWait',
    textPath: 'vision.landing.benefits.dayOne',
  },
];

const testimonials = [
  {
    imgSrc:
      'https://images.contentful.com/heg7gyzix6dq/2oWbgIf93mSguycaUc8e8w/ce84ac179c928cf4a2488e005dba37be/Testimonial1.svg',
    quotePath: 'vision.landing.testimonials.testimonial1',
    authorPath: 'vision.landing.testimonials.author1',
  },
  {
    imgSrc:
      'https://images.contentful.com/heg7gyzix6dq/59V8LnVCGk2MSUkWmGk0Y0/a7db8e875d5d7089045a2294a62ccc97/Testimonial2.svg',
    quotePath: 'vision.landing.testimonials.testimonial2',
    authorPath: 'vision.landing.testimonials.author2',
  },
];

class VisionLandingPage extends PureComponent<Props> {
  static defaultProps = {
    submitHandler: () => {},
  };

  render() {
    return (
      <div className="vision-landing">
        {/* Hero */}
        <div className="hero-container">
          <div className="hero">
            <div className="center-col">
              <div>
                <h1>
                  <span style={{ display: 'inline-block' }}>
                    <Translate path="vision.landing.betterVision" />
                  </span>{' '}
                  <span style={{ display: 'inline-block' }}>
                    <Translate path="vision.landing.halfPrice" />
                  </span>
                </h1>
                <h4 style={{ paddingTop: 8 }}>
                  <Translate path="vision.landing.visionInsurance" />
                </h4>
                <div>
                  <InputZip
                    className="focus-white-color vision-page-zip"
                    label={{ path: 'common.label.zipCode' }}
                    buttonLabel={{ path: 'vision.landing.findPlanBtn' }}
                    initialValue=""
                    submitHandler={this.props.submitHandler}
                    hideIconSearch />
                </div>
              </div>
            </div>
          </div>

          <div className="hero-card-container">
            <Card className="white-bg" style={{ margin: 0 }}>
              <div className="row medium-table v-middle">
                <div className="td medium-6 text-center pad-right">
                  <div className="flex-row center large-pad-right">
                    <div className="col-medium">
                      <div>
                        <img
                          alt="vision_hero"
                          src="https://images.contentful.com/heg7gyzix6dq/2uBnpAFrQE4Wu20kYwIg6M/038cad92bae488a33c1dd0c2a7869e56/vision.svg" />
                      </div>
                      <div className="mini grey-4-color pad-top">
                        <Translate path="vision.landing.individualPrice" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="td medium-6 pad-left">
                  <div className="grey-2-color pad-top-2-small-only">
                    <h3>
                      <Translate path="vision.landing.stridePrice" />
                    </h3>
                    <p>
                      <Translate path="vision.landing.unbeatablePrice" />
                    </p>
                    <span className="price">
                      <h4 style={{ display: 'inline', fontWeight: 700 }}>$9.12</h4> a month
                    </span>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>

        {/* Banner  */}
        <div className="vision-banner">
          <h4>
            <Translate path="vision.landing.banner" />
          </h4>
        </div>

        {/* Benefits section */}
        <section className="vision-benefits">
          <div className="row">
            {visionBenefits.map(benefit => (
              <div className="column medium-4" key={benefit.imgSrc}>
                <div className="benefit">
                  <div>
                    <img src={benefit.imgSrc} alt={benefit.alt} />
                  </div>
                  <h3 className="pad-top">
                    <Translate path={benefit.headerPath} />
                  </h3>
                  <div className="pad-top-half">
                    <Translate path={benefit.textPath} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Testimonials */}
        <section className="vision-testimonials">
          <Testimonials testimonials={testimonials} />
        </section>

        {/* CTA */}
        <section className="find-vision">
          <div className="row pad-x medium-table v-middle">
            <div className="td medium-6 left-content">
              <div className="large-flex-row center">
                <div className="large-col-medium">
                  <h2>
                    <Translate path="vision.landing.visionInsurance" />
                  </h2>
                  <div className="pad-top">
                    <Translate path="vision.landing.signup" />
                  </div>
                  <div className="pad-top-2">
                    <LinkButton
                      to="/onboarding/location"
                      className="cta-button"
                      onClick={() => {
                        Tracking.track('CTA: Vision');
                      }}>
                      <Translate path="vision.landing.findPlan" />
                    </LinkButton>
                  </div>
                </div>
              </div>
            </div>
            <div className="td medium-6 right-content text-center">
              <img
                alt="Vision_plan-iphone"
                style={{ width: 310, transform: 'translateY(5rem)' }}
                src="https://images.contentful.com/heg7gyzix6dq/3pvHVHNN7Ge4QUckg4SIQU/84dfe641bb9cb04ab4835b089d9ee8cd/Vision_plan-iphone.png" />
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default VisionLandingPage;
